import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function ScreenTitle(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <h1
            className={props.className}
            dangerouslySetInnerHTML={{ __html: props.text }}
        />
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

ScreenTitle.propTypes = {
    className: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
}

ScreenTitle.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledScreenTitle = styled(ScreenTitle)`
    & {
        font-family: "Poppins-Bold";
        font-size: 50px;
        text-align: center;

        @media (max-width: 768px) {
            font-size: 30px;
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledScreenTitle
